module.exports = __webpack_public_path__ + "img/hzico_1.c324b93d.jpg";